import { createFileRoute } from '@tanstack/react-router';

import { TestIndexPage } from '../features/dev/test-index-page.js';
import { devOnlyGuard } from './-dev-only.js';

export const Route = createFileRoute('/test/')({
  beforeLoad: devOnlyGuard,
  component: TestIndexPage,
});
